
// Few language constants in Highcharts are managed from this file
// by just importing the exported constant function or a variable.
export const months = {
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    fr: ['fr-Jan', 'fr-Feb', 'fr-Mar', 'fr-Apr', 'fr-May', 'fr-Jun', 'fr-Jul', 'fr-Aug', 'fr-Sep', 'fr-Oct', 'fr-Nov', 'fr-Dec']
}